/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontFeaturedSection_user = {
    readonly " $fragmentRefs": FragmentRefs<"StorefrontProductGrid_user">;
    readonly " $refType": "StorefrontFeaturedSection_user";
};
export type StorefrontFeaturedSection_user$data = StorefrontFeaturedSection_user;
export type StorefrontFeaturedSection_user$key = {
    readonly " $data"?: StorefrontFeaturedSection_user$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontFeaturedSection_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "StorefrontFeaturedSection_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "StorefrontProductGrid_user",
      "args": null
    }
  ]
};
(node as any).hash = 'cc33e765bcfb2cbd86cb6ba9c7c0cfd9';
export default node;
